import clsx from "clsx";
import { useState, React } from "react";
import { Link } from "react-router-dom";
import { SocialIcon } from "react-social-icons";

export const SignIn = () => {
  return (
    <div className="text-primary flex flex-col gap-2 items-center my-10">
      <div className="flex flex-col gap-6">
        <div className="text-4xl lg:text-5xl  font-semibold">
          Sign In
          <br />
          To Join Our Circle
        </div>
        <div className="text-lg font-semibold">
          New to DonorAssist?&nbsp;
          <Link className="text-pink " to="/signup">
            Sign Up
          </Link>
          &nbsp;Here
        </div>
        <form className="flex flex-col gap-2" action="" method="post">
          <label className="text-dark font-semibold" htmlFor="email">
            Email
          </label>
          <input
            className="border border-b-dark border-transparent bg-transparent"
            type="email"
            name="email"
            id="email"
          />
          <label className="text-dark font-semibold" htmlFor="password">
            Password
          </label>
          <input
            className="border border-b-dark border-transparent bg-transparent"
            type="password"
            name="password"
            id="password"
          />
          <div className="flex gap-2 justify-start items-center">
            <input
              className="cursor-pointer"
              type="checkbox"
              name="forget"
              id="forget"
            />
            <label className="text-primary font-semibold" htmlFor="forget">
              Forgot your Password
            </label>
          </div>
          <button
            className="bg-primary text-white py-2 rounded-md my-4"
            type="submit"
          >
            Sign In
          </button>
        </form>
      </div>
      <div className="flex flex-col items-center gap-2">
        <div className="lg:text-3xl font-semibold">Or Continue with</div>
        <div className="flex gap-10 lg:text-xl font-bold ">
          <div
            className="cursor-pointer border flex items-center border-primary rounded-md  px-4 lg:px-10 py-1"
            draggable
          >
            <SocialIcon network="facebook" />
            &nbsp;
            <div>Facebook</div>
          </div>
          <div
            className="cursor-pointer border flex items-center border-primary rounded-md px-4 lg:px-10 py-1"
            draggable
          >
            <SocialIcon network="google" />
            &nbsp;
            <div>Google</div>
          </div>
        </div>
      </div>
      <div className="text-center font-semibold">
        By signing in you agree to our Terms of Service
        {/* <Link className="text-pink ">Terms of Service</Link> */}
      </div>
    </div>
  );
};
export const SignUp = () => {
  const [form, setForm] = useState("individual");
  return (
    <div className="text-primary mx-4 md:flex md:flex-col gap-2 md:justify-center items-center my-10 ">
      <div className="flex flex-col gap-6">
        <div className="text-3xl lg:text-5xl  font-semibold">
          Sign Up
          <br />
          To Create a New Account
        </div>
        <div className="text-lg font-semibold">
          Already have an account?&nbsp;
          <Link className="text-pink " to="/signin">
            Sign In
          </Link>
          &nbsp;Here
        </div>
        <form className="flex flex-col gap-2" action="" method="post">
          <div className="flex justify-between">
            <div>
              <input
                type="radio"
                name="individual"
                id="individual"
                onClick={() => {
                  setForm("individual");
                }}
                defaultChecked
              />
              <label htmlFor="individual">&nbsp;&nbsp;INDIVIDUAL</label>
            </div>
            <div>
              <input
                type="radio"
                name="individual"
                id="business"
                onClick={() => {
                  setForm("business");
                }}
              />
              <label htmlFor="business">&nbsp;&nbsp;BUSINESS</label>
            </div>
            <div>
              <input
                type="radio"
                name="individual"
                id="non-profit"
                onClick={() => {
                  setForm("non-profit");
                }}
              />
              <label htmlFor="non-profit">&nbsp;&nbsp;NON-PROFIT</label>
            </div>
          </div>
          <div className="flex justify-between gap-2">
            <div className="flex flex-col w-2/4">
              <label className="text-dark font-semibold" htmlFor="first-name">
                First Name
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent "
                type="name"
                name="first-name"
                id="first-name"
              />
            </div>
            <div className="flex flex-col w-2/4">
              <label className="text-dark font-semibold" htmlFor="last-name">
                Last Name
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent "
                type="name"
                name="last-name"
                id="last-name"
              />
            </div>
          </div>

          <div
            className={clsx(
              "hidden justify-between gap-2",
              form !== "individual" && "!flex"
            )}
          >
            <div
              className={clsx(
                "flex flex-col w-full",
                form !== "business" && "!w-2/4"
              )}
            >
              <label className="text-dark font-semibold" htmlFor="company">
                Company
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent"
                type="name"
                name="company"
                id="company"
              />
            </div>
            <div
              className={clsx(
                " hidden flex-col w-2/4",
                form === "non-profit" && "!flex"
              )}
            >
              <label className="text-dark font-semibold" htmlFor="ein">
                EIN#
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent"
                type="code"
                name="ein"
                id="ein"
              />
            </div>
          </div>

          <label className="text-dark font-semibold" htmlFor="recipient">
            Recipient
          </label>
          <input
            className="border border-b-dark border-transparent bg-transparent"
            type="name"
            name="recipient"
            id="recipient"
          />
          <div className="flex gap-2 justify-start items-center">
            <input
              className="cursor-pointer"
              type="checkbox"
              name="same"
              id="same"
            />
            <label className="text-dark font-semibold" htmlFor="same">
              Same as above
            </label>
          </div>

          <div className="flex justify-between gap-2">
            <div className="flex flex-col w-2/4">
              <label className="text-dark font-semibold" htmlFor="email">
                Email
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent"
                type="email"
                name="email"
                id="email"
              />
            </div>
            <div className="flex flex-col w-2/4">
              <label className="text-dark font-semibold" htmlFor="phone">
                Phone Number
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent"
                type="phone"
                name="phone"
                id="phone"
              />
            </div>
          </div>
          <div className="flex justify-between gap-2">
            <div className="flex flex-col w-2/4">
              <label className="text-dark font-semibold" htmlFor="password">
                Password
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent"
                type="password"
                name="password"
                id="password"
              />
            </div>
            <div className="flex flex-col w-2/4">
              <label className="text-dark font-semibold" htmlFor="v-password">
                Verify Password
              </label>
              <input
                className="border border-b-dark border-transparent bg-transparent"
                type="password"
                name="v-password"
                id="v-password"
              />
            </div>
          </div>
          <div className="flex gap-2 justify-start items-center">
            <input
              className="cursor-pointer"
              type="checkbox"
              name="show-password"
              id="show-password"
            />
            <label className="text-dark font-semibold" htmlFor="show-password">
              Show Password
            </label>
          </div>

          <button
            className="bg-primary text-white py-2 rounded-md my-4"
            type="submit"
          >
            Sign Up
          </button>
        </form>
      </div>
      <div className="flex flex-col items-center gap-2">
        <div className="lg:text-3xl font-semibold">Or Continue with</div>
        <div className="flex gap-10 lg:text-xl font-bold ">
          <div
            className="cursor-pointer border flex items-center border-primary rounded-md  px-4 lg:px-10 py-1"
            draggable
          >
            <SocialIcon network="facebook" />
            &nbsp;
            <div>Facebook</div>
          </div>
          <div
            className="cursor-pointer border flex items-center border-primary rounded-md px-4 lg:px-10 py-1"
            draggable
          >
            <SocialIcon network="google" />
            &nbsp;
            <div>Google</div>
          </div>
        </div>
      </div>
      <div className="text-center font-semibold mt-4 md:mt-0">
        By signing in you agree to our Terms of Service
        {/* <Link className="text-pink ">Terms of Service</Link> */}
      </div>
    </div>
  );
};
